module.exports = __webpack_public_path__ + "img/icon_blanc.20f7f528.svg";